/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Skip_DescInputs */

const vi_einvoice_skip_desc = /** @type {(inputs: Einvoice_Skip_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn lý do để cả nhóm biết vì sao đơn này không có hóa đơn.`)
};

/**

* @param {Einvoice_Skip_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_skip_desc = /** @type {((inputs?: Einvoice_Skip_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Skip_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_skip_desc(inputs)
});